import React, { Component } from 'react';
import MessageError from "../MessageError/index";
import MessageSuccess from "../MessageSuccess/index";

const pStyle = {
  marginLeft: '10px'
};

export default class MessageErrorSuccess extends Component {
  render() {
    return (
      <div style={pStyle}>
        {
          !this.props.correct ?
          <MessageError icon={true} textAlign='left' message={this.props.errorMsg} />
          :
          <MessageSuccess icon={true} textAlign='left' message={this.props.successMsg} />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/MessageErrorSuccess/index.js